(() => {
  'use strict';

  const config = window.KingTheme || {};
  const root = config.root || '/';
  const endpoint = (path) => `${path}.js`;
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  const money = (cents = 0) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: config.currency || 'MAD', maximumFractionDigits: 2
      }).format(Number(cents) / 100);
    } catch (_) {
      return `${(Number(cents) / 100).toFixed(2)} ${config.currency || 'MAD'}`;
    }
  };

  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    $$('.drawer-shell.is-open').forEach((item) => closeDrawer(item));
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    window.setTimeout(() => $('[data-search-input]', drawer)?.focus(), 320);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer-shell.is-open')) document.body.classList.remove('drawer-open');
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.dataset.drawerOpen);
      return;
    }
    const closer = event.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('.drawer-shell'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      $$('.drawer-shell.is-open').forEach(closeDrawer);
      $('[data-lightbox].is-open [data-lightbox-close]')?.click();
    }
  });

  const header = $('[data-site-header]');
  if (header) {
    const syncHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 36);
    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });
  }

  $$('[data-minimal-fashion]').forEach((section) => {
    const cards = $$('[data-minimal-card]', section);
    const activate = (active) => cards.forEach((card) => {
      card.classList.toggle('is-active', card === active);
      if (window.matchMedia('(min-width: 1024px)').matches) card.style.flex = card === active ? '2.2 1 0%' : '1 1 0%';
    });
    cards.forEach((card) => {
      card.addEventListener('mouseenter', () => activate(card));
      card.addEventListener('focus', () => activate(card));
      card.addEventListener('click', (event) => {
        if (!event.target.closest('a,button')) activate(card);
      });
    });
  });

  $$('[data-scroll-target]').forEach((button) => button.addEventListener('click', () => {
    const rail = document.getElementById(button.dataset.scrollTarget);
    if (!rail) return;
    const direction = Number(button.dataset.scrollDirection || 1);
    rail.scrollBy({ left: direction * Math.max(260, rail.clientWidth * 0.72), behavior: 'smooth' });
  }));

  $$('[data-manifesto]').forEach((section) => {
    const words = $$('.manifesto-word', section);
    const reveal = () => {
      const rect = section.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, (window.innerHeight - rect.top) / (window.innerHeight + rect.height * 0.6)));
      const visible = Math.ceil(progress * words.length);
      words.forEach((word, index) => word.classList.toggle('is-revealed', index < visible));
    };
    reveal();
    window.addEventListener('scroll', reveal, { passive: true });
  });

  $$('[data-countdown]').forEach((section) => {
    const key = 'king-countdown-end';
    const days = Number(section.dataset.countdownDays || 140);
    let end = Number(localStorage.getItem(key));
    if (!end || end < Date.now()) {
      end = Date.now() + days * 86400000;
      localStorage.setItem(key, String(end));
    }
    const update = () => {
      const remaining = Math.max(0, end - Date.now());
      const values = {
        days: Math.floor(remaining / 86400000),
        hours: Math.floor((remaining / 3600000) % 24),
        minutes: Math.floor((remaining / 60000) % 60),
        seconds: Math.floor((remaining / 1000) % 60)
      };
      Object.entries(values).forEach(([name, value]) => {
        const node = $(`[data-countdown-value="${name}"]`, section);
        if (node) node.textContent = String(value).padStart(2, '0');
      });
    };
    update();
    window.setInterval(update, 1000);
  });

  async function request(url, options = {}) {
    const response = await fetch(url, {
      ...options,
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', ...(options.headers || {}) }
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.description || payload.message || 'Impossible de mettre à jour votre panier.');
    return payload;
  }

  async function getCart() {
    return request(endpoint(config.cart || `${root}cart`), { method: 'GET', headers: { 'Content-Type': 'application/json' } });
  }

  function cartLine(item) {
    const image = item.featured_image?.url || item.image || '';
    const variant = item.product_has_only_default_variant ? '' : `<p class="truncate text-xs text-muted-foreground">${escapeHTML(item.variant_title || '')}</p>`;
    return `<li class="flex gap-3 p-4" data-cart-line="${escapeHTML(item.key)}">
      <div class="h-20 w-20 shrink-0 overflow-hidden rounded-xl bg-fog">${image ? `<img src="${escapeHTML(image)}" alt="${escapeHTML(item.product_title)}" loading="lazy" class="h-full w-full object-contain p-1.5">` : ''}</div>
      <div class="min-w-0 flex-1"><p class="truncate text-sm font-semibold text-ink">${escapeHTML(item.product_title)}</p>${variant}<p class="mt-1 text-sm font-bold">${money(item.final_line_price)}</p>
      <div class="mt-2 flex items-center gap-2"><div class="inline-flex items-center rounded-full border border-border"><button type="button" data-cart-change="${escapeHTML(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" class="grid h-8 w-8 place-items-center rounded-l-full hover:bg-fog" aria-label="Diminuer">−</button><span class="w-8 text-center text-xs font-semibold">${item.quantity}</span><button type="button" data-cart-change="${escapeHTML(item.key)}" data-quantity="${item.quantity + 1}" class="grid h-8 w-8 place-items-center rounded-r-full hover:bg-fog" aria-label="Augmenter">+</button></div><button type="button" data-cart-change="${escapeHTML(item.key)}" data-quantity="0" class="grid h-8 w-8 place-items-center rounded-full hover:bg-fog" aria-label="Supprimer">×</button></div></div></li>`;
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach((node) => {
      node.textContent = cart.item_count;
      node.hidden = cart.item_count === 0;
    });
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    const items = $('[data-cart-items]', drawer);
    const empty = $('[data-cart-empty]', drawer);
    const subtotalWrap = $('[data-cart-subtotal-wrap]', drawer);
    const checkout = $('[data-checkout]', drawer);
    const titleCount = $('[data-cart-title-count]', drawer);
    if (titleCount) titleCount.textContent = cart.item_count;
    if (items) {
      items.innerHTML = cart.items.map(cartLine).join('');
      items.hidden = cart.item_count === 0;
    }
    if (empty) empty.hidden = cart.item_count > 0;
    if (subtotalWrap) subtotalWrap.hidden = cart.item_count === 0;
    const subtotal = $('[data-cart-subtotal]', drawer);
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (checkout) checkout.disabled = cart.item_count === 0;
  }

  async function addItems(items, open = true) {
    if (!items.length) return;
    await request(endpoint(config.cartAdd || `${root}cart/add`), { method: 'POST', body: JSON.stringify({ items }) });
    renderCart(await getCart());
    if (open) openDrawer('cart-drawer');
  }

  document.addEventListener('click', async (event) => {
    const quickAdd = event.target.closest('[data-quick-add]');
    if (quickAdd) {
      event.preventDefault();
      quickAdd.disabled = true;
      try { await addItems([{ id: Number(quickAdd.dataset.quickAdd), quantity: 1 }]); }
      catch (error) { window.alert(error.message); }
      finally { quickAdd.disabled = false; }
      return;
    }
    const change = event.target.closest('[data-cart-change]');
    if (change) {
      change.disabled = true;
      try {
        const cart = await request(endpoint(config.cartChange || `${root}cart/change`), { method: 'POST', body: JSON.stringify({ id: change.dataset.cartChange, quantity: Number(change.dataset.quantity) }) });
        renderCart(cart);
      } catch (error) { window.alert(error.message); }
      return;
    }
    if (event.target.closest('[data-checkout]')) window.location.href = `${root}checkout`;
  });

  $$('form[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const submitter = event.submitter;
    const button = submitter || $('[data-add-to-cart]', form);
    if (button) button.disabled = true;
    const id = Number($('[name="id"]', form)?.value);
    const quantity = Number($('[name="quantity"]', form)?.value || 1);
    try {
      await addItems([{ id, quantity }], submitter?.name !== 'checkout');
      if (submitter?.name === 'checkout') window.location.href = `${root}checkout`;
    } catch (error) { window.alert(error.message); }
    finally { if (button) button.disabled = false; }
  }));

  const productPage = $('[data-product-page]');
  if (productPage) {
    const form = $('form[data-product-form]', productPage);
    const input = $('[data-variant-input]', form);
    $$('[data-variant-option]', productPage).forEach((option) => option.addEventListener('click', () => {
      if (option.disabled) return;
      $$('[data-variant-option]', productPage).forEach((item) => item.setAttribute('aria-pressed', String(item === option)));
      input.value = option.dataset.variantId;
      const price = Number(option.dataset.variantPrice || 0);
      const compare = Number(option.dataset.variantCompare || 0);
      const available = option.dataset.variantAvailable === 'true';
      $('[data-variant-label]', productPage).textContent = option.dataset.variantTitle;
      $('[data-product-price]', productPage).textContent = money(price);
      const compareNode = $('[data-product-compare]', productPage);
      if (compareNode) { compareNode.textContent = money(compare); compareNode.hidden = compare <= price; }
      const savingNode = $('[data-product-saving]', productPage);
      if (savingNode) { savingNode.textContent = `Économisez ${money(Math.max(0, compare - price))} aujourd’hui`; savingNode.hidden = compare <= price; }
      const discountNode = $('[data-product-discount]', productPage);
      if (discountNode) { discountNode.textContent = compare > price ? `-${Math.round((compare - price) * 100 / compare)}%` : ''; discountNode.hidden = compare <= price; }
      $$('[data-add-to-cart], [data-sticky-add]', productPage).forEach((button) => { button.disabled = !available; });
      const label = $('[data-add-label]', productPage); if (label) label.textContent = available ? 'Ajouter au panier' : 'Indisponible';
      const stockLabel = $('[data-stock-label]', productPage); if (stockLabel) stockLabel.textContent = available ? 'En stock — expédition sous 24 heures' : 'Épuisé';
      const dot = $('[data-stock-dot]', productPage); if (dot) { dot.classList.toggle('bg-success', available); dot.classList.toggle('bg-destructive', !available); }
      const url = new URL(window.location.href); url.searchParams.set('variant', option.dataset.variantId); history.replaceState({}, '', url);
    }));

    $$('[data-qty-change]', productPage).forEach((button) => button.addEventListener('click', () => {
      const quantity = $('[data-quantity-input]', productPage);
      quantity.value = Math.max(Number(quantity.min || 1), Math.min(Number(quantity.max || 99), Number(quantity.value || 1) + Number(button.dataset.qtyChange)));
    }));

    const gallery = $('[data-mobile-gallery]', productPage);
    if (gallery) {
      const dots = $$('[data-gallery-dots] > *', productPage);
      const current = $('[data-gallery-current]', productPage);
      const sync = () => {
        const index = Math.max(0, Math.min(dots.length - 1, Math.round(gallery.scrollLeft / gallery.clientWidth)));
        if (current) current.textContent = index + 1;
        dots.forEach((dot, i) => { dot.className = `h-1.5 rounded-full transition-all ${i === index ? 'w-6 bg-ink' : 'w-1.5 bg-ink/25'}`; });
        $$('[data-gallery-thumb]', productPage).forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      };
      gallery.addEventListener('scroll', sync, { passive: true });
      $$('[data-gallery-thumb]', productPage).forEach((thumb) => thumb.addEventListener('click', () => gallery.scrollTo({ left: Number(thumb.dataset.galleryThumb) * gallery.clientWidth, behavior: 'smooth' })));
    }

    const sticky = $('[data-mobile-sticky]', productPage);
    if (sticky && form) {
      const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
      observer.observe(form);
      $('[data-sticky-add]', sticky)?.addEventListener('click', () => $('[data-add-to-cart]', form)?.click());
    }

    const lightbox = $('[data-lightbox]');
    if (lightbox) {
      const sources = $$('[data-lightbox-open]', productPage).map((button) => $('img', button)?.currentSrc || $('img', button)?.src).filter(Boolean);
      let index = 0;
      const show = () => { $('[data-lightbox-image]', lightbox).src = sources[index] || ''; };
      $$('[data-lightbox-open]', productPage).forEach((button) => button.addEventListener('click', () => { index = Number(button.dataset.lightboxOpen) % Math.max(1, sources.length); show(); lightbox.classList.add('is-open'); document.body.classList.add('drawer-open'); }));
      $('[data-lightbox-close]', lightbox)?.addEventListener('click', () => { lightbox.classList.remove('is-open'); document.body.classList.remove('drawer-open'); });
      $('[data-lightbox-prev]', lightbox)?.addEventListener('click', () => { index = (index - 1 + sources.length) % sources.length; show(); });
      $('[data-lightbox-next]', lightbox)?.addEventListener('click', () => { index = (index + 1) % sources.length; show(); });
    }
  }

  $$('[data-accordion-trigger]').forEach((trigger) => trigger.addEventListener('click', () => {
    const item = trigger.closest('.accordion-item');
    const open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', String(open));
  }));

  $$('[data-bundle]').forEach((section) => {
    const selected = new Set();
    const items = $$('[data-bundle-item]', section);
    const totalNode = $('[data-bundle-total]', section);
    const addButton = $('[data-bundle-add]', section);
    const slots = $$('[data-bundle-slot]', section);
    const sync = () => {
      const chosen = items.filter((item) => selected.has(item.dataset.variantId));
      const total = chosen.reduce((sum, item) => sum + Number(item.dataset.price || 0), 0);
      items.forEach((item) => item.classList.toggle('is-selected', selected.has(item.dataset.variantId)));
      slots.forEach((slot, index) => {
        const item = chosen[index];
        slot.innerHTML = item ? `<img src="${escapeHTML(item.dataset.image || '')}" alt="${escapeHTML(item.dataset.title)}" class="h-full w-full rounded-2xl object-contain p-1">` : '<span class="text-xl text-muted-foreground">+</span>';
        slot.classList.toggle('border-dashed', !item);
      });
      if (totalNode) totalNode.textContent = money(total);
      if (addButton) { addButton.disabled = chosen.length === 0; addButton.textContent = chosen.length ? `${money(total)}: Ajouter au panier` : `${money(0)}: Ajouter au panier`; addButton.classList.toggle('bg-ink', chosen.length > 0); addButton.classList.toggle('text-bone', chosen.length > 0); }
    };
    items.forEach((item) => $('.bundle-toggle', item)?.addEventListener('click', () => { const id = item.dataset.variantId; selected.has(id) ? selected.delete(id) : selected.add(id); sync(); }));
    addButton?.addEventListener('click', async () => {
      addButton.disabled = true;
      try { await addItems(items.filter((item) => selected.has(item.dataset.variantId)).map((item) => ({ id: Number(item.dataset.variantId), quantity: 1 }))); }
      catch (error) { window.alert(error.message); }
      sync();
    });
    sync();
  });

  $$('[data-addons]').forEach((section) => {
    const options = $$('[data-addon]', section);
    const sync = () => {
      const chosen = options.filter((option) => option.classList.contains('is-selected'));
      const total = chosen.reduce((sum, option) => sum + Number(option.dataset.price || 0), 0);
      $('[data-addon-count]', section).textContent = chosen.length;
      $('[data-addon-total]', section).textContent = money(total);
      $('[data-addons-add]', section).disabled = chosen.length === 0;
    };
    options.forEach((option) => option.addEventListener('click', () => { option.classList.toggle('is-selected'); sync(); }));
    $('[data-addons-add]', section)?.addEventListener('click', async () => {
      const button = $('[data-addons-add]', section); button.disabled = true;
      try { await addItems(options.filter((option) => option.classList.contains('is-selected')).map((option) => ({ id: Number(option.dataset.variantId), quantity: 1 }))); }
      catch (error) { window.alert(error.message); }
      sync();
    });
  });

  const shipping = $('[data-shipping-countdown]');
  if (shipping) {
    let remaining = 7 * 3600;
    window.setInterval(() => {
      remaining = Math.max(0, remaining - 1);
      const h = Math.floor(remaining / 3600); const m = Math.floor((remaining % 3600) / 60); const s = remaining % 60;
      shipping.textContent = [h, m, s].map((value) => String(value).padStart(2, '0')).join(':');
    }, 1000);
  }
})();
